import { MASTER_DATA } from "../constants";

const initialState = {
    regionMaster: [],
    airportMaster: [],
    countryMaster: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case MASTER_DATA.SET_MASTER_DATA:
            const { regionMaster, airportMaster, countryMaster } = action.payload || {};
            return {
                ...state,
                regionMaster: regionMaster ?? state.regionMaster,
                airportMaster: airportMaster ?? state.airportMaster,
                countryMaster: countryMaster ?? state.countryMaster,
            };
        case MASTER_DATA.CLEAR:
            return {
                ...state,
                regionMaster: [],
                airportMaster: [],
                countryMaster: []
            };
        default:
            return state;
    }
}
